export const headerClients = [
  "Nome",
  "CPF/CNPJ" ,
  "Estado",
  "Cidade",
  "Status",
  "Números"
]

export const optionsActions = [
  "Exportar dados do cliente",
]



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/components/MyCustomers/constants.js